var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.2,12l-1.2-1.2,4.8-4.8L3,1.2l1.2-1.2,4.8,4.8L13.8,0l1.2,1.2-4.8,4.8,4.8,4.8-1.2,1.2-4.8-4.8-4.8,4.8Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseDark);
export default __webpack_public_path__ + "static/media/icon-close-dark.1417999d794f30063177e24b769f241f.svg";
export { ForwardRef as ReactComponent };